import { render, staticRenderFns } from "./cmpskeletondashboard2.vue?vue&type=template&id=4a340333&scoped=true&"
import script from "./cmpskeletondashboard2.vue?vue&type=script&lang=js&"
export * from "./cmpskeletondashboard2.vue?vue&type=script&lang=js&"
import style0 from "./cmpskeletondashboard2.vue?vue&type=style&index=0&id=4a340333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a340333",
  null
  
)

export default component.exports